import { render, staticRenderFns } from "./modulePage.vue?vue&type=template&id=c52d6860&scoped=true"
import script from "./modulePage.vue?vue&type=script&lang=js"
export * from "./modulePage.vue?vue&type=script&lang=js"
import style0 from "./modulePage.vue?vue&type=style&index=0&id=c52d6860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52d6860",
  null
  
)

export default component.exports